/**
 * Müstakil Dükkan - Koku Barı Variant Controller
 *
 * Simplified variant controller for scent-only products.
 * Handles:
 * - Scent selection via text-pill buttons
 * - Image gallery filtering by koku: alt tags
 * - Dynamic per-variant description swapping
 * - Price and cart updates
 */

class KokuVariantController {
  constructor(productData, variantsData) {
    this.product = productData;
    this.variants = variantsData;
    this.imagesData = this.parseImagesData();
    this.currentVariant = this.getInitialVariant();

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateUI();
  }

  parseImagesData() {
    var dataEl = document.getElementById('product-images-data');
    if (!dataEl) return { images: [] };
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Failed to parse images data:', e);
      return { images: [] };
    }
  }

  getInitialVariant() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');

    if (variantId) {
      var variant = this.variants.find(function(v) { return v.id == variantId; });
      if (variant) return variant;
    }

    return this.variants.find(function(v) { return v.available; }) || this.variants[0];
  }

  bindEvents() {
    var self = this;

    // Scent pill buttons
    document.querySelectorAll('.koku-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        if (e.currentTarget.disabled) return;
        var koku = e.currentTarget.dataset.kokuValue;
        self.selectScent(koku);
      });
    });

    // Gallery thumbnails
    document.querySelectorAll('.gallery-thumbnail').forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        var index = parseInt(e.currentTarget.dataset.index);
        self.selectImageByIndex(index);
      });
    });

    // Gallery navigation arrows
    var prevBtn = document.querySelector('.gallery-nav-prev');
    var nextBtn = document.querySelector('.gallery-nav-next');

    if (prevBtn) prevBtn.addEventListener('click', function() { self.navigateGallery(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { self.navigateGallery(1); });

    // Touch swipe for mobile
    var galleryMain = document.querySelector('.gallery-main');
    if (galleryMain) {
      var touchStartX = 0;
      galleryMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function(e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          self.navigateGallery(diff > 0 ? 1 : -1);
        }
      }, { passive: true });
    }
  }

  selectScent(koku) {
    var targetVariant = this.variants.find(function(v) {
      return v.option1 === koku;
    });

    if (targetVariant) {
      this.currentVariant = targetVariant;
      this.updateUI();
      this.updateURL();
    }
  }

  updateUI() {
    this.updateScentButtons();
    this.updateDescription();
    this.updateGallery();
    this.updatePrice();
    this.updateAddToCart();
    this.updateTitle();
    this.updateQuantityLimits();

    window.dispatchEvent(new CustomEvent('variantChange', {
      detail: { variant: this.currentVariant }
    }));
  }

  updateTitle() {
    var titleEl = document.getElementById('product-title-dynamic');
    var subtitleEl = document.getElementById('product-koku-subtitle');

    if (titleEl) {
      titleEl.textContent = this.product.title;
    }

    if (subtitleEl) {
      subtitleEl.textContent = this.currentVariant.option1;
    }
  }

  updateScentButtons() {
    var currentKoku = this.currentVariant.option1;

    document.querySelectorAll('.koku-btn').forEach(function(btn) {
      var koku = btn.dataset.kokuValue;
      btn.classList.toggle('active', koku === currentKoku);
    });

    // Update label value
    var labelEl = document.getElementById('koku-label-value');
    if (labelEl) {
      labelEl.textContent = currentKoku;
    }
  }

  updateDescription() {
    var currentKoku = this.currentVariant.option1;
    var kokuHandle = currentKoku.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

    // Hide all scent descriptions, show the current one
    document.querySelectorAll('[data-scent-description]').forEach(function(el) {
      if (el.dataset.scentDescription === kokuHandle) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  updateGallery() {
    var currentKoku = this.currentVariant.option1;

    var filteredImages = this.imagesData.images.filter(function(img) {
      // Show images tagged with current scent
      if (img.koku === currentKoku) return true;
      // Show shared images (no koku tag)
      if (img.koku === null) return true;
      return false;
    });

    var mainContainer = document.getElementById('gallery-main-image');
    var thumbContainer = document.getElementById('gallery-thumbnails');
    var self = this;

    if (mainContainer && filteredImages.length > 0) {
      mainContainer.innerHTML = filteredImages.map(function(img, index) {
        return '<img ' +
          'src="' + img.src + '" ' +
          'data-src="' + img.srcLarge + '" ' +
          'data-zoom="' + img.srcZoom + '" ' +
          'alt="' + (img.alt || '') + '" ' +
          'class="gallery-main-img' + (index === 0 ? ' active' : '') + '" ' +
          'data-image-id="' + img.id + '" ' +
          'data-index="' + index + '" ' +
          'width="800" height="800" ' +
          'loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
      }).join('');
    }

    if (thumbContainer && filteredImages.length > 0) {
      thumbContainer.innerHTML = filteredImages.map(function(img, index) {
        return '<button ' +
          'class="gallery-thumbnail' + (index === 0 ? ' active' : '') + '" ' +
          'data-image-id="' + img.id + '" ' +
          'data-index="' + index + '" ' +
          'aria-label="View image ' + (index + 1) + '">' +
          '<img src="' + img.thumb + '" alt="' + (img.alt || '') + '" width="85" height="85" loading="lazy">' +
          '</button>';
      }).join('');

      thumbContainer.querySelectorAll('.gallery-thumbnail').forEach(function(thumb) {
        thumb.addEventListener('click', function(e) {
          var index = parseInt(e.currentTarget.dataset.index);
          self.selectImageByIndex(index);
        });
      });
    }

    this.currentImageIndex = 0;
  }

  selectImageByIndex(index) {
    var mainImages = document.querySelectorAll('.gallery-main-img');
    var thumbnails = document.querySelectorAll('.gallery-thumbnail');

    mainImages.forEach(function(img, i) {
      img.classList.toggle('active', i === index);
    });

    thumbnails.forEach(function(thumb, i) {
      thumb.classList.toggle('active', i === index);
    });

    this.currentImageIndex = index;
  }

  navigateGallery(direction) {
    var mainImages = document.querySelectorAll('.gallery-main-img');
    var totalImages = mainImages.length;

    if (totalImages === 0) return;

    var newIndex = (this.currentImageIndex || 0) + direction;

    if (newIndex < 0) newIndex = totalImages - 1;
    if (newIndex >= totalImages) newIndex = 0;

    this.selectImageByIndex(newIndex);
  }

  updatePrice() {
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var discountBadgeEl = document.querySelector('[data-discount-badge]');
    var discountPctEl = document.querySelector('[data-discount-pct]');
    var hasDiscount = this.currentVariant.compare_at_price > this.currentVariant.price;

    if (priceEl) {
      priceEl.textContent = this.formatMoney(this.currentVariant.price);
    }

    if (comparePriceEl) {
      if (hasDiscount) {
        comparePriceEl.textContent = this.formatMoney(this.currentVariant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (discountBadgeEl) {
      if (hasDiscount) {
        var pct = Math.floor((this.currentVariant.compare_at_price - this.currentVariant.price) * 100 / this.currentVariant.compare_at_price);
        if (discountPctEl) discountPctEl.textContent = pct;
        discountBadgeEl.style.display = '';
      } else {
        discountBadgeEl.style.display = 'none';
      }
    }
  }

  updateAddToCart() {
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    var variantInput = document.querySelector('input[name="id"]');

    if (variantInput) {
      variantInput.value = this.currentVariant.id;
      variantInput.disabled = !this.currentVariant.available;
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !this.currentVariant.available;

      var btnText = addToCartBtn.querySelector('[data-add-to-cart-text]');
      if (btnText) {
        btnText.textContent = this.currentVariant.available ? '+ SEPETE EKLE' : 'TÜKENDİ';
      }
    }
  }

  updateQuantityLimits() {
    var quantityInput = document.querySelector('.md-qty-input');
    if (quantityInput) {
      var maxQty = this.currentVariant.inventory_policy === 'continue'
        ? 9999
        : Math.max(1, this.currentVariant.inventory_quantity || 1);

      quantityInput.setAttribute('max', maxQty);

      var currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > maxQty) {
        quantityInput.value = maxQty;
      }
    }
  }

  updateURL() {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', url.toString());
  }

  formatMoney(cents) {
    var amount = cents / 100;
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount).replace('₺', '₺');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var productDataEl = document.getElementById('product-json-data');
  var variantsDataEl = document.getElementById('product-variants-data');

  if (productDataEl && variantsDataEl) {
    try {
      var productData = JSON.parse(productDataEl.textContent);
      var variantsData = JSON.parse(variantsDataEl.textContent);

      window.productVariantController = new KokuVariantController(productData, variantsData);
    } catch (e) {
      console.error('Failed to initialize KokuVariantController:', e);
    }
  }
});
